/**
 * GA4-standard data builders for ecommerce events.
 */
function buildGA4VehicleItem(vehicle, index) {
    const price = vehicle.basePrice ?? vehicle.price ?? vehicle.advertisedPrice ?? 0;
    const yearStr = vehicle.modelYear ? `${vehicle.modelYear} ` : '';
    const itemName = vehicle.name ??
        vehicle.content_name ??
        `${yearStr}${vehicle.make ?? ''} ${vehicle.model ?? ''}`.trim();
    return {
        item_id: vehicle.productId ?? vehicle.id ?? vehicle.content_id ?? '',
        item_name: itemName,
        item_brand: vehicle.make,
        item_category: vehicle.vehicleCategory,
        item_variant: vehicle.variantId,
        price,
        quantity: 1,
        ...(index !== undefined && { index }),
    };
}
function buildGA4AccessoryItem(accessory) {
    return {
        item_id: accessory.id ?? '',
        item_name: accessory.name ?? '',
        price: accessory.price ?? accessory.basePrice ?? 0,
        quantity: accessory.quantity ?? 1,
        item_category: 'accessory',
    };
}
function buildGA4Items(vehicles, accessories) {
    const items = vehicles.map((v, i) => buildGA4VehicleItem(v, i));
    if (accessories) {
        for (const acc of accessories) {
            items.push(buildGA4AccessoryItem(acc));
        }
    }
    return items;
}
function buildEcommercePayload(input) {
    const payload = {
        value: input.value ?? input.items.reduce((sum, i) => sum + i.price * i.quantity, 0),
        currency: input.currency ?? 'USD',
        items: input.items,
    };
    if (input.transactionId)
        payload.transaction_id = input.transactionId;
    if (input.tax !== undefined)
        payload.tax = input.tax;
    if (input.shipping !== undefined)
        payload.shipping = input.shipping;
    if (input.affiliation)
        payload.affiliation = input.affiliation;
    if (input.shippingTier)
        payload.shipping_tier = input.shippingTier;
    if (input.paymentType)
        payload.payment_type = input.paymentType;
    if (input.itemListName)
        payload.item_list_name = input.itemListName;
    return payload;
}
async function sha256(value) {
    const encoder = new TextEncoder();
    const data = encoder.encode(value.trim().toLowerCase());
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}
function normalizePhone(phone) {
    const digits = phone.replaceAll(/\D/g, '');
    return digits.startsWith('1') ? `+${digits}` : `+1${digits}`;
}
async function buildHashedAddress(input) {
    const address = {};
    if (input.firstName)
        address.sha256_first_name = await sha256(input.firstName);
    if (input.lastName)
        address.sha256_last_name = await sha256(input.lastName);
    if (input.postalCode)
        address.postal_code = input.postalCode.trim();
    if (input.city)
        address.city = input.city.trim().toLowerCase();
    if (input.region)
        address.region = input.region.trim().toUpperCase();
    address.country = input.country?.trim().toUpperCase() || 'US';
    return address;
}
async function buildHashedUserData(input) {
    const result = {};
    if (input.email) {
        result.sha256_email_address = await sha256(input.email);
    }
    if (input.phone) {
        result.sha256_phone_number = await sha256(normalizePhone(input.phone));
    }
    const hasAddress = input.firstName || input.lastName || input.postalCode || input.city || input.region;
    if (hasAddress) {
        result.address = await buildHashedAddress(input);
    }
    return result;
}

export { buildEcommercePayload, buildGA4AccessoryItem, buildGA4Items, buildGA4VehicleItem, buildHashedUserData };
//# sourceMappingURL=data-builders.js.map
